const getPaginationRange = (current, pages) => {
  const newCurrent = current + 1;

  const delta = newCurrent > 1 ? 1 : 2;
  const left = newCurrent - delta;
  const right = newCurrent + delta + 1;
  const rangeWithDots = [];

  // calculate which page numbers to show
  const range = [];
  for (let i = 1; i <= pages; i += 1) {
    if (i === 1 || i === pages || (i >= left && i < right)) {
      range.push(i);
    }
  }

  let previousPageNo;

  for (let i = 0; i < range.length; i += 1) {
    const valueInRangeArr = range[i];
    if (previousPageNo) {
      if (valueInRangeArr - previousPageNo === 2) {
        rangeWithDots.push(previousPageNo + 1);
      } else if (valueInRangeArr - previousPageNo !== 1) {
        rangeWithDots.push("...");
      }
    }
    rangeWithDots.push(valueInRangeArr);
    previousPageNo = valueInRangeArr;
  }

  return rangeWithDots;
};

const paginationTemplate = (paginationObj) => {
  const rangeWithDots = getPaginationRange(
    paginationObj.currentRefinement,
    paginationObj.nbPages
  );
  let paginationMarkup = "";

  if (!paginationObj.isFirstPage) {
    paginationMarkup += `
      <li>
        <a
          href="${paginationObj.createURL(paginationObj.currentRefinement - 1)}"
          data-page-index="${paginationObj.currentRefinement - 1}"
          class="list-pagination__link list-pagination__link-prev">
          <span class="list-pagination__link-icon">
            <svg height="12" width="9" viewBox="0 0 12 9" xmlns="http://www.w3.org/2000/svg"><path d="M7.9 1.4L6.5 0l-6 6 6 6 1.4-1.4L3.3 6l4.6-4.6z" fill="white" fill-rule="evenodd"/></svg>
          </span>
          Previous
        </a>
      </li>
    `;
  }

  rangeWithDots.forEach((page) => {
    if (page === "...") {
      paginationMarkup +=
        ' <li><span class="list-pagination__dots">...</span></li>';
    } else {
      paginationMarkup += `
        <li>
          <a
            href="${paginationObj.createURL(page - 1)}"
            data-page-index="${page - 1}"
            class="list-pagination__link ${
              paginationObj.currentRefinement === page - 1
                ? "list-pagination__link--active"
                : ""
            }">
            ${page}
          </a>
        </li>`;
    }
  });

  if (!paginationObj.isLastPage) {
    paginationMarkup += `
      <li>
        <a
          href="${paginationObj.createURL(paginationObj.currentRefinement + 1)}"
          data-page-index="${paginationObj.currentRefinement + 1}"
          class="list-pagination__link list-pagination__link-next">
          Next
          <span class="list-pagination__link-icon">
            <svg height="12" width="9" viewBox="0 0 12 9" xmlns="http://www.w3.org/2000/svg"><path d="M1.5 0L.1 1.4 4.7 6 .1 10.6 1.5 12l6-6-6-6z" fill="white" fill-rule="evenodd"/></svg>
          </span>
        </a>
      </li>`;
  }

  return paginationMarkup;
};

const renderPagination = (renderOptions, isFirstRender) => {
  const { pages, refine, widgetParams } = renderOptions;
  const container = widgetParams.container;

  if (isFirstRender) return;

  if (pages.length > 1) {
    container.innerHTML = paginationTemplate(renderOptions);

    container.querySelectorAll(".list-pagination__link").forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();

        refine(e.currentTarget.dataset.pageIndex);

        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      });
    });
  } else {
    container.innerHTML = "";
  }
};

export const pagination =
  window.instantsearch.connectors.connectPagination(renderPagination);
